import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gmplay',
    templateUrl: './gmplay.component.html',
    styleUrls: ['./gmplay.component.scss'],
    standalone: false
})
export class GmplayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
